import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Layout } from "@/components/Layout";
import { Seo, organizationSchema } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";

export const LegalPage = ({ title, updated, description, path, intro, sections }) => (
  <Layout>
    <Seo title={title} description={description} path={path} jsonLd={[organizationSchema]} />

    <section className="relative overflow-hidden border-b border-stroke">
      <div className="pointer-events-none absolute inset-0 grid-dots opacity-50" />
      <div className="relative mx-auto max-w-4xl px-5 sm:px-8 py-14 lg:py-16">
        <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-slatey">
          <Link to="/" className="hover:text-brand">Home</Link>
          <ChevronRight className="h-3.5 w-3.5" aria-hidden="true" />
          <span className="font-medium text-ink">{title}</span>
        </nav>
        <Reveal className="mt-5">
          <h1 className="text-4xl font-bold tracking-tight text-ink sm:text-5xl">{title}</h1>
          <p className="mt-3 text-sm text-slatey">Last updated: {updated}</p>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-slatey">{intro}</p>
        </Reveal>
      </div>
    </section>

    <section className="mx-auto max-w-4xl px-5 sm:px-8 py-14 lg:py-16">
      <div className="space-y-10">
        {sections.map((s, i) => (
          <Reveal key={s.h} delay={Math.min(i * 0.03, 0.15)}>
            <article>
              <h2 className="text-xl font-bold tracking-tight text-ink">
                {i + 1}. {s.h}
              </h2>
              {s.p.map((para, j) => (
                <p key={j} className="mt-3 text-[0.95rem] leading-relaxed text-slatey">
                  {para}
                </p>
              ))}
              {s.list && (
                <ul className="mt-3 space-y-2">
                  {s.list.map((li) => (
                    <li key={li} className="flex gap-2 text-[0.95rem] leading-relaxed text-slatey">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-brand" />
                      {li}
                    </li>
                  ))}
                </ul>
              )}
            </article>
          </Reveal>
        ))}
      </div>

      <div className="mt-14 rounded-2xl border border-stroke bg-canvas p-6 text-sm text-slatey">
        Questions about this page? Contact us at{" "}
        <a href="mailto:hello@elikya.tech" className="font-semibold text-brand hover:text-brand-hover">
          hello@elikya.tech
        </a>{" "}
        or visit our{" "}
        <Link to="/contact" className="font-semibold text-brand hover:text-brand-hover">
          contact page
        </Link>
        .
      </div>
    </section>
  </Layout>
);
